/**
 * sw-deferred-component
 *
 * Loads a fragment of html from any endpoint and performs any necessry view-building
 * on said fragment.
 *
 * The url used is picked based on the value of the following, prioritized in the order listed. data-sw-deferred-compoonent, href. (if it's a dropdown we use value)
 *
 * You may add latency to this process by attaching a millisecond value to the GET paramter 'sleepy-time'
 *
 * Usage:
 *
 * sw-deferred-component=<endpoint>
 *
 *   Declare the endpoint from which a fragment should be loaded
 *
 * sw-deferred-component-on=<DOM event>
 *
 *   Declare the event that triggers the deferred component
 *
 * sw-deferred-component-debounce-event=<time (ms)>
 *
 *   Debounces DOM events to not overload a server when listening to keyup/keydown/etc.
 *
 * sw-deferred-component-target=<jQuery Selector>
 *
 *   Specify the box that will be appended to by the deferred component
 *
 * sw-deferred-component-replace-method=<"append"|"html"|"replaceWith">
 *
 *   Specify what method to use for the deferrred content placement in the DOM when sw-deferred-component-target is present.
 *    - Append is default
 *
 * sw-deferred-component-token=<token>
 *
 *   Token to verify against DOS attacks
 *
 * sw-deferred-component-input-name
 *
 *   If deferred component is an input type, then name the parameter
 *
 * sw-deferred-component-input-pattern
 *
 *   If deferred component is an input type, specify pattern on which to make request
 *
 * sw-deferred-component-clear-before-request=<true|false>
 *
 *   If true, will empty the contents of the target before making a new request
 *
 * sw-deferred-component-*
 *
 *   Arbitrary list of key value pairs to be sent as parameters to the endpoint
 *
 * sw-deferred-component-dropdown
 *
 *   Indicates that this deferred component is a dropdown and should make requests on change to the dropdown
 *
 * sw-deferred-component-no-auto
 *
 *   Don't act like an autohandler
 *
 * sw-deferred-component-use-noty=<true|false>
 *
 *   Put response into a noty
 *
 * sw-deferred-component-dynamic-values=<true|false>
 *
 *   Re-sets the attributes before submitting if the parameter values can change
 *   after initialization but before fetching the component
 *
 * sw-deferred-component-complete-event=<string>
 *
 *   Event to fire when this deferred component has loaded.
 *
 * sw-deferred-component-use-noty-layout=<layoutName>
 *
 *  Specify layout for noty to use
 *
 * sw-deferred-component-use-noty-type=<type>
 *
 *  Specify type for noty to use
 *
 * sw-deferred-component-with-credentials=<bool>
 *
 *  Whether or not to send the request to the fragment endpoint with credentials.
 *
 * sw-deferred-component-auto-delay=<int>
 *
 *   Automatically kicks off deferred component once after a delay
 * 
 * Events:
 *
 *  @publishes sw-fragment-loaded
 */

var $ = require('js/sw-jquery/sw-jquery');
var DeferredComponentView = require('js/lib/views/DeferredComponent');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-deferred-component]').each(function() {
    var $el = $(this);
    new DeferredComponentView({
      el: $el
    });
  });

};
